import { IDashboardLayout } from 'components/Visualization/CDashboard/types';

import { availableWidgets1 } from './widget';

export const dashboardWidgets1: IDashboardLayout = {
  id: 'dashboard_1',
  title: 'Dashboard Title',
  widgets: [
    {
      type: 'card',
      i: 'buckets',
      x: 0,
      y: 0,
      w: 3,
      h: 2.5,
      isResizable: false,
      static: true,
    },
    {
      type: 'card',
      i: 'databases',
      x: 3,
      y: 0,
      w: 3,
      h: 2.5,
      isResizable: false,
      static: true,
    },
    {
      type: 'card',
      i: 'disks',
      x: 6,
      y: 0,
      w: 3,
      h: 2.5,
      isResizable: false,
      static: true,
    },
    {
      type: 'card',
      i: 'saas',
      x: 9,
      y: 0,
      w: 3,
      h: 2.5,
      isResizable: false,
      static: true,
    },
    {
      type: 'table',
      i: 'highRiskDataSourcesWithSensitiveData',
      x: 0,
      y: 2.5,
      w: 6,
      h: 8.9,
      minH: 6,
      minW: 4,
      isResizable: false,
      static: true,
    },
    {
      type: 'table',
      i: 'runtimeInsightsForDataSources',
      x: 6,
      y: 2.5,
      w: 6,
      h: 8.9,
      minH: 6,
      minW: 4,
      isResizable: false,
      static: true,
    },
    {
      type: 'table',
      i: 'dataSourcesByAccounts',
      x: 0,
      y: 11.4,
      w: 4,
      h: 8,
      minH: 6,
      minW: 4,
      isResizable: false,
      static: true,
    },
    {
      type: 'table',
      i: 'dataFootprintByRegion',
      x: 4,
      y: 11.4,
      w: 4,
      h: 8,
      minH: 6,
      minW: 4,
      isResizable: false,
      static: true,
    },
    {
      type: 'table',
      i: 'dataFootprintBySourceTypes',
      x: 8,
      y: 11.4,
      w: 4,
      h: 8,
      minH: 6,
      minW: 4,
      isResizable: false,
      static: true,
    },
    {
      type: 'table',
      i: 'documentsByTypes',
      x: 0,
      y: 19.4,
      w: 4,
      h: 8,
      minH: 6,
      minW: 4,
      isResizable: false,
      static: true,
    },
    {
      type: 'table',
      i: 'sensitiveDataByType',
      x: 4,
      y: 19.4,
      w: 4,
      h: 8,
      minH: 6,
      minW: 4,
      isResizable: false,
      static: true,
    },
    {
      type: 'pie-chart',
      i: 'sensitiveDataByRegion',
      x: 8,
      y: 19.4,
      w: 4,
      h: 8,
      minH: 6,
      minW: 4,
      isResizable: false,
      static: true,
    },
  ],
  available: availableWidgets1,
};
